import { ICoordinates } from 'react-give-me-map';

export function get3dFeature(
    id: string,
    level: number,
    base_height: number,
    height: number,
    color: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    coordinates: any[]
) {
    return {
        type: 'Feature',
        properties: {
            level,
            name: id,
            base_height,
            height,
            color
        },
        geometry: {
            coordinates: [coordinates],
            type: 'Polygon'
        },
        id
    };
}

export function coordsToArrays(coords: ICoordinates[]) {
    return coords.map((coord) => [coord.lng, coord.lat]) as [
        [number, number],
        [number, number],
        [number, number],
        [number, number]
    ];
}
